import {Menu, MenuType} from "./menu-item-shared";

export const dashboardMenu: Menu = {
  state: 'dashboard',
  name: 'menu.dashboard',
  type: MenuType.Static,
  icon: 'explore'
};
